<form [formGroup]="form" class="flex flex-col gap-4">
  @let minlength = serverConfig.data.userPasswordValidation.minlength;
  @let maxlength = serverConfig.data.userPasswordValidation.maxlength;
  <div class="space-y-2">
    <label for="password" class="block font-medium text-sm select-none"
      >Wachtwoord</label
    >

    <mat-form-field class="w-full">
      <input
        matInput
        formControlName="password"
        autocomplete="new-password"
        enterkeyhint="next"
        id="password"
        type="password"
      />

      @if (controls.password.hasError('required')) {
        <mat-error>Vul je nieuwe wachtwoord in</mat-error>
      } @else if (controls.password.hasError('minlength')) {
        <mat-error
          >Minimaal {{ minlength }}
          {{ minlength > 1 ? 'karakters' : 'karakter' }}</mat-error
        >
      } @else if (controls.password.hasError('maxlength')) {
        <mat-error>Maximaal {{ maxlength }} karakters</mat-error>
      }
    </mat-form-field>
  </div>

  <div class="space-y-2">
    <label for="verifyPassword" class="block font-medium text-sm select-none"
      >Herhaal wachtwoord</label
    >

    <mat-form-field class="w-full">
      <input
        matInput
        formControlName="verifyPassword"
        autocomplete="new-password"
        enterkeyhint="next"
        id="verifyPassword"
        type="password"
      />

      @if (controls.verifyPassword.hasError('equal')) {
        <mat-error>Je wachtwoord komt niet overeen</mat-error>
      }
    </mat-form-field>
  </div>

  <button mat-flat-button (click)="submit()">Wachtwoord wijzigen</button>
</form>
